import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteTestimonial } from "../../api/apiTestimonials";
import parseError from "../../utils/parseError";

export function useDeleteTestimonial() {
    const queryClient = useQueryClient();

    const { mutate: deleteItemMutate, isPending } = useMutation({
        mutationFn: deleteTestimonial,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["testimonials"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete testimonial");
        },
    });

    return { deleteItemMutate, isPending };
}
